import { createSlice } from '@reduxjs/toolkit';
import type { DocumentDetailsState } from './types';
import { fetchDocumentDetails, fetchDocumentByNumber } from './thunk';

const initialState: DocumentDetailsState = {
  loading: false,
  error: null,
  document: null,
};

const docsVerificationSlice = createSlice({
  name: 'docsVerification',
  initialState,
  reducers: {
    clearDocumentDetails: (state) => {
      state.loading = false;
      state.error = null;
      state.document = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.document = null;
      })
      .addCase(fetchDocumentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.document = action.payload;
      })
      .addCase(fetchDocumentDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Failed to fetch document details';
        state.document = null;
      })

      .addCase(fetchDocumentByNumber.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.document = null;
      })
      .addCase(fetchDocumentByNumber.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.document = action.payload;
      })
      .addCase(fetchDocumentByNumber.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Failed to fetch document by number';
        state.document = null;
      });
  },
});

export const { clearDocumentDetails } = docsVerificationSlice.actions;
export default docsVerificationSlice.reducer;
